import { render, staticRenderFns } from "./GridLoader.vue?vue&type=template&id=651462fa"
import script from "./GridLoader.vue?vue&type=script&lang=js"
export * from "./GridLoader.vue?vue&type=script&lang=js"
import style0 from "./GridLoader.vue?vue&type=style&index=0&id=651462fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports